<template>
  <div class="q-pa-md" style="max-width: 560px; margin: 0 auto">
    <q-card>
      <q-card-section>
        <div class="text-h5 q-mb-md">Вход в партнёрский кабинет</div>

        <q-banner v-if="status" class="bg-green-1 text-green-9 q-mb-md" rounded>
          <div class="row items-center q-col-gutter-sm">
            <div class="col">
              {{ status }}
            </div>
            <div v-if="canResendVerification" class="col-auto">
              <q-btn
                color="primary"
                outline
                label="Отправить ещё раз"
                type="button"
                :loading="resendForm.processing"
                no-caps
                @click="resend"
              />
            </div>
          </div>
        </q-banner>

        <q-form @submit.prevent="submit">
          <q-input
            v-model="form.email"
            label="Email"
            type="email"
            autocomplete="email"
            outlined
            dense
            :error="!!form.errors.email"
            :error-message="form.errors.email"
            class="q-mb-md"
          />
          <q-input
            v-model="form.password"
            label="Пароль"
            type="password"
            autocomplete="current-password"
            outlined
            dense
            :error="!!form.errors.password"
            :error-message="form.errors.password"
            class="q-mb-md"
          />

          <div class="row items-center q-col-gutter-sm">
            <div class="col">
              <q-checkbox v-model="form.remember" label="Запомнить меня" dense />
            </div>
            <div class="col-auto">
              <q-btn color="primary" label="Войти" type="submit" :loading="form.processing" no-caps />
            </div>
          </div>

          <div class="row q-mt-md">
            <div class="col">
              <a :href="route('partner.register')" class="text-primary">Регистрация</a>
            </div>
            <div class="col-auto">
              <a :href="route('partner.password.request')" class="text-primary">Забыли пароль?</a>
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import { useForm, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

defineProps({
  status: { type: String, default: null },
})

const page = usePage()
const canResendVerification = computed(() => {
  const partner = page.props?.auth?.partner
  return !!partner?.is_partner && !partner?.email_verified_at
})

const form = useForm({
  email: '',
  password: '',
  remember: false,
})

const resendForm = useForm({})

const submit = () => {
  form.post(route('partner.login.store'))
}

const resend = () => {
  resendForm.post(route('partner.verification.send'))
}
</script>

